module.exports = __webpack_public_path__ + "images/ds-lda-instructor-davis-balaba-mobile.webp";